// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://api-www-uat.vdam.com.vn/api/',
  apiDomain: 'api-www-uat.vdam.com.vn',
  imgBaseUrl: 'https://api-www-uat.vdam.com.vn/Resources/Images/',
  fileBaseUrl: 'https://api-www-uat.vdam.com.vn/Resources/Files/',
  selfUrl: 'https://www-uat.vdam.com.vn/',
};

// export const environment = {
//   production: true,
//   apiUrl: 'https://api.vdam.com.vn/api/',
//   apiDomain: 'api.vdam.com.vn',
//   imgBaseUrl: 'https://api.vdam.com.vn/Resources/Images/',
//   fileBaseUrl: 'https://api.vdam.com.vn/Resources/Files/',
//   selfUrl: 'https://vdam.com.vn/',
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
